import { defineComponent } from 'vue';
import { QIcon } from 'quasar';
import utils from '../../../Shared/utils.jsx';
import BaseComponentMixin from './BaseComponentMixin.jsx';

const PREVIEW_NAV = [
    { icon: 'mdi-home-variant', active: true },
    { icon: 'mdi-view-dashboard-outline', active: false },
    { icon: 'mdi-account-group', active: false },
    { icon: 'mdi-cog-outline', active: false },
];

const PREVIEW_TABS = [
    { title: 'Sample Tab', active: true },
    { title: 'Another Tab', active: false },
];

export default defineComponent({
    name: 'call-center-home-dsgn',
    mixins: [BaseComponentMixin],
    components: {
        QIcon,
    },
    computed: {
        rootStyle() {
            return {
                display: 'flex',
                flexDirection: 'column',
                flexGrow: 1,
                minHeight: '220px',
                height: '100%',
                width: '100%',
                overflow: 'hidden',
                backgroundColor: '#f5f5f7',
                border: 'solid 1px silver',
                borderRadius: '8px',
                ...utils.resolveStyleHints(this.controlData?.StyleHints, this),
                ...utils.getSize(this.controlData?.SizeOptions, this.parentType, this.$parent),
            };
        },
        bannerColor() {
            return this.controlData?.PreviewBannerColor || 'var(--q-primary, #1976d2)';
        },
        customerLabel() {
            return this.controlData?.PreviewCustomerName || 'Sample Customer';
        },
    },
    render() {
        if (!this.controlData)
            return null;

        const navItems = PREVIEW_NAV.map((item, i) => (
            <div
                key={i}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '40px',
                    height: '40px',
                    margin: '4px auto',
                    borderRadius: '8px',
                    backgroundColor: item.active ? 'rgba(255,255,255,0.18)' : 'transparent',
                    color: '#fff',
                    opacity: item.active ? 1 : 0.75,
                }}>
                <QIcon name={item.icon} size="22px" />
            </div>
        ));

        const tabs = PREVIEW_TABS.map((tab, i) => (
            <div
                key={i}
                style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '6px',
                    padding: '0 12px',
                    height: tab.active ? '40px' : '34px',
                    alignSelf: 'flex-end',
                    borderTopLeftRadius: '8px',
                    borderTopRightRadius: '8px',
                    backgroundColor: tab.active ? '#2e2e3c' : '#4a4a5c',
                    color: tab.active ? '#fff' : 'rgba(255,255,255,0.68)',
                    fontSize: '12px',
                    whiteSpace: 'nowrap',
                }}>
                <span>{tab.title}</span>
                <QIcon name="mdi-close-circle" size="14px" />
            </div>
        ));

        return (
            <div
                class={{
                    'designer-container': true,
                    selected: this.selected$,
                    'c-CallCenterHome': true,
                    [`c-name-${this.name || 'unnamed'}`]: true,
                }}
                style={this.rootStyle}
                onClick={(e) => this.handleClick(e)}>
                <div class={{ 'designer-container-hovering': true, 'designer-container-selected': this.selected$ }} />

                {/* Title bar preview */}
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        flexShrink: 0,
                        height: '60px',
                        minHeight: '60px',
                        padding: '0 8px',
                        gap: '8px',
                        backgroundColor: this.bannerColor,
                        color: '#fff',
                    }}>
                    <div
                        style={{
                            width: '36px',
                            height: '36px',
                            borderRadius: '8px',
                            backgroundColor: 'rgba(255,255,255,0.25)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexShrink: 0,
                        }}>
                        <QIcon name="mdi-domain" size="22px" />
                    </div>
                    <div
                        style={{
                            fontSize: '1.15rem',
                            fontWeight: 500,
                            maxWidth: '220px',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                        }}>
                        {this.customerLabel}
                    </div>
                    <div
                        style={{
                            flex: '1 1 auto',
                            minWidth: 0,
                            display: 'flex',
                            alignItems: 'flex-end',
                            height: '100%',
                            gap: '2px',
                        }}>
                        {tabs}
                    </div>
                    <div
                        style={{
                            flexShrink: 0,
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px',
                            opacity: 0.9,
                            fontSize: '11px',
                        }}>
                        <QIcon name="mdi-bell-outline" size="18px" />
                        <span style={{ opacity: 0.75 }}>Title right</span>
                    </div>
                </div>

                {/* Main: nav + content */}
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        flex: '1 1 auto',
                        minHeight: 0,
                        overflow: 'hidden',
                    }}>
                    <div
                        style={{
                            width: '56px',
                            minWidth: '56px',
                            backgroundColor: 'var(--q-dark, #1d1d1d)',
                            display: 'flex',
                            flexDirection: 'column',
                            paddingTop: '8px',
                        }}>
                        {navItems}
                        <div style={{ flex: '1 1 auto' }} />
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '40px',
                                height: '40px',
                                margin: '8px auto',
                                color: '#fff',
                                opacity: 0.7,
                            }}>
                            <QIcon name="mdi-menu" size="22px" />
                        </div>
                    </div>

                    <div
                        style={{
                            flex: '1 1 auto',
                            minWidth: 0,
                            minHeight: 0,
                            display: 'flex',
                            flexDirection: 'column',
                            backgroundColor: '#fff',
                            borderTop: '1px solid #e0e0e0',
                        }}>
                        <div
                            style={{
                                padding: '16px',
                                color: '#666',
                                fontSize: '13px',
                            }}>
                            <div style={{ fontWeight: 600, color: '#333', marginBottom: '6px' }}>
                                CallCenterHome
                                {this.name ? ` (${this.name})` : ''}
                            </div>
                            <div>
                                Designer preview — title bar, navigation drawer, and content host.
                                Runtime loads menus, background services, and areas.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    },
});
